const paymentMethods = {
    /* eslint-disable sort-keys */
    CREDIT_CARD: 1,
    ACH: 2,
    HR: 3,
    /* eslint-enable sort-keys */
} as const;

export default paymentMethods;
